import script from "./EstudanteHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./EstudanteHomeView.vue?vue&type=script&setup=true&lang=js"

import "./EstudanteHomeView.vue?vue&type=style&index=0&id=d3348da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3348da6"]])

export default __exports__